import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API_BASE_URL;

export default function AdminGuard({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }

    axios.get(`${API}/auth/me`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        if (res.data.role === "ADMIN") {
          setIsAdmin(true);
        }
      })
      .catch(() => setIsAdmin(false))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) return <div>Checking...</div>;

  if (!token) return <Navigate to="/login" replace />;

  if (!isAdmin) return <Navigate to="/" replace />;

  return children;
}